export default "__VITE_ASSET__BVPde3YE__"